import { modifyMutable, produce } from "solid-js/store"
import { useSelectedToolSignal } from "../../../../rx/signal/useSelectedToolSignal"
import calculateDraftMoveRangedAttackEstimates from "../../draft_move/calculateDraftMoveRangedAttackEstimates"
import type { DraftMove } from "../../draft_move/DraftMove.type"
import type { Engine } from "../../engine/Engine.type"
import isEntityAtFullMobility from "../../entity/isEntityAtFullMobility"
import unitHasRangedAttackWeapon from "../../entity/unitHasRangedAttackWeapon"
import { SelectedToolId } from "../../map_editor/SelectedToolId.enum"
import { samePosition } from "../../tile_position_xy/samePosition"

export default function handlePreviewRangedAttackOptions(engine: Engine) {
  // console.log('handlePreviewRangedAttackOptions')
  const { draftMove } = engine
  if (!draftMove) {
    return null
  }
  const [getSelectedTool, setSelectedTool] = useSelectedToolSignal(engine)

  const selectedTool = getSelectedTool()
  if (shouldOfferPreviewRangedAttackOptions(engine)) {
    modifyMutable(engine, produce((engine : Engine) => {
      if (selectedTool === SelectedToolId.RangedAttackRadius) {
        setSelectedTool(SelectedToolId.MoveUnit)
      } else {
        const newDraftMove : DraftMove = {
          ...draftMove,
          destPosition: null,
          attackPosition: null,
          target: null,
        }
        setSelectedTool(SelectedToolId.RangedAttackRadius)
        engine.draftMove = newDraftMove
        calculateDraftMoveRangedAttackEstimates(engine, engine.draftMove)
      }
    }))
  }
}

export function shouldOfferPreviewRangedAttackOptions(engine: Engine) {
  // console.log('handlePreviewRangedAttackOptions')
  const { draftMove } = engine
  if (draftMove) {
    const { attackPosition, destPosition, unit } = draftMove

    if (attackPosition) {
      return
    }
    const [getSelectedTool] = useSelectedToolSignal(engine)
    const selectedTool = getSelectedTool()
    if (selectedTool !== SelectedToolId.MoveUnit) {
      return
    }
    if (!samePosition(destPosition || unit, unit)) {
      return
    }
    if (!isEntityAtFullMobility(unit)) {
      return
    }
    if (!unitHasRangedAttackWeapon(unit)) {
      return
    }
    return true
  }
}